
import React from 'react';
import { ApplicationStatus } from '../types';

interface BadgeProps {
  status: ApplicationStatus;
}

export const Badge: React.FC<BadgeProps> = ({ status }) => {
  const styles = {
    [ApplicationStatus.NEW]: 'bg-purple-100 text-purple-700 border-purple-200',
    [ApplicationStatus.WELCOME_SENT]: 'bg-blue-100 text-blue-700 border-blue-200',
    [ApplicationStatus.SIGNED_ONBOARDED]: 'bg-green-100 text-green-700 border-green-200',
    [ApplicationStatus.ARCHIVED]: 'bg-gray-100 text-gray-400 border-gray-200',
  };

  return (
    <span className={`px-2 py-0.5 rounded border text-[9px] font-black uppercase tracking-tighter ${styles[status]}`}>
      {status}
    </span>
  );
};
